import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { BlDetails, ClientesBl } from 'src/app/interfaces/bl.interfaces';
import { CustomerBusinessName } from 'src/app/interfaces/lotes.interfaces';

import { WorkBook, read, WorkSheet, utils, SSF } from 'xlsx';

type AOA = any[][];

enum CheckSheets {
  previous_registration_id = 2,
  identification_stored_merchandise_id,
}

interface BatchList {
  operation_id: number;
  bl_id: number;
  pieces_batch: any[]
}

@Component({
  selector: 'app-read-xlsx',
  templateUrl: './read-xlsx.component.html',
  styleUrls: ['./read-xlsx.component.css']
})
/**
 * Componente de carga de lotes desde un archivo Excel.
 *
 * Lee las hojas del archivo, las normaliza y valida (tipos, fechas, columnas
 * obligatorias y razones sociales del cliente) y emite los datos formateados
 * de los lotes de piezas listos para su creación.
 */
export class ReadXlsxComponent {
  @Input() customersBl: ClientesBl[] = [];
  @Input() blDetails!: BlDetails;
  @Output() onLoadFile = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  data: AOA = [];
  dataSheet2: AOA = [];
  dataSheet3: AOA = [];
  JsonData: any;
  JsonDataSheet2: any;
  JsonDataSheet3: any;
  formattedData: BatchList = {
    operation_id: 0,
    bl_id: 0,
    pieces_batch: []
  };
  customerOverlay: boolean = false;
  customerId: FormControl = new FormControl('', Validators.required);
  customersWithPieces: ClientesBl[] = [];
  selectedCustomer!: any;
  customerBusinessName: CustomerBusinessName[] = [];
  requiredBatchProperties: string[] = ['customer_id',	'id_business_name',	'bl_lot_id',	'material_group_id',
    'material_id',	'packing_id',	'tonnage',	'quantity_pieces',	'location_id',	'shipper_receiver',
    'address_shipper_receiver',	'consignee_name',	'address_consignee'
  ];
  entryProperties: string[] = ['location_id_entry', 'entry_date', 'customs_agent'];
  stringProperties: string[] = [
    'bl_lot_id', 'shipper_receiver', 'address_shipper_receiver', 'consignee_name', 'address_consignee',
    'address', 'container_dimension', 'container_type', 'number_container_seals', 'number_container_locks',
    'unconsolidated_container', 'deconsolidated_store', 'unconsolidated_means_transport',
    'consolidated_container', 'consolidated_store', 'consolidated_means_transport', 'customs_agent',
    'amount_merchandise_deposit', 'compensation_amount', 'customer_lot_number', 'observations',
    'damage_violation_record', 'identification_stored_merchandise', 'pama_number', 'fiscal_folio_cfdi',
    'total_amount_presentation', 'total_amount_cfdi', 'trade_number'
  ];
  numericProperties: string[] = [
    'customer_id', 'id_business_name', 'material_group_id', 'material_id', 'packing_id', 'tonnage',
    'quantity_pieces', 'location_id', 'location_id_entry', 'sample_weight', 'weight_embargoed_merchandise'
  ];
  dateProperties: string[] = ['entry_date', 'sampling_date', 'office_date'];
  clientPropoerties: string[] = ['customer_id', 'material_id', 'id_presentation'];
  // Largo máximo permitido por columna de texto (debe coincidir con el esquema
  // 'create_batch_pieces' del backend; solo aplica a columnas tipo string).
  stringMaxLengths: { [property: string]: number } = {
    customer_lot_number: 100,
    bl_lot_id: 20,
    shipper_receiver: 100,
    address_shipper_receiver: 150,
    consignee_name: 300,
    address_consignee: 150,
    pama_number: 150,
    fiscal_folio_cfdi: 150,
    total_amount_cfdi: 150,
    total_amount_presentation: 150,
    amount_merchandise_deposit: 150,
    compensation_amount: 150,
    address: 150,
    container_dimension: 150,
    container_type: 150,
    number_container_seals: 150,
    number_container_locks: 150,
    unconsolidated_container: 150,
    deconsolidated_store: 150,
    unconsolidated_means_transport: 150,
    consolidated_container: 150,
    consolidated_store: 150,
    consolidated_means_transport: 150,
  };
  errorMessage: string = '';
  // Indica que el error actual es por exceder el largo máximo de una columna.
  // Estos errores muestran el overlay con botón y sin cierre automático.
  isLengthError: boolean = false;
  currentUser: string = '';
  errorOverlay: boolean = false;
  buttons: boolean = false;
  message: string = '';
  icon: string = '';
  loading: boolean = false;

  constructor(
    private loteSvc: LoteService,
    private localStorageSvc: LocalStorageService,
  ) {}

  hangleLoadFile() {
    this.customersWithPieces = this.customersBl.filter( customer => customer.id_presentation !== 1 );
    if (this.customersWithPieces.length > 1) {
      this.togleCustomerOverlay();
    } else {
      this.findCustomer(this.customersWithPieces[0].id);
      this.loadFile();
    }
  }

  /**
   * Lee el archivo Excel seleccionado, extrae sus tres hojas, formatea las
   * fechas y dispara la validación de los datos.
   * @param evt - Evento de cambio del input de archivo.
   */
  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    // return if there is not file
    if (target.files.length !== 1) return;
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: WorkBook = read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: WorkSheet = wb.Sheets[wsname];

      /* grab second sheet */
      const wsname2: string = wb.SheetNames[1];
      const ws2: WorkSheet = wb.Sheets[wsname2];

      /* grab first sheet */
      const wsname3: string = wb.SheetNames[2];
      const ws3: WorkSheet = wb.Sheets[wsname3];

      /* save data */
      this.data = [];
      this.dataSheet2 = [];
      this.dataSheet3 = [];
      this.data = <AOA>(utils.sheet_to_json(ws, { header: 1 }));
      this.dataSheet2 = <AOA>(utils.sheet_to_json(ws2, { header: 1 }));
      this.dataSheet3 = <AOA>(utils.sheet_to_json(ws3, { header: 1 }));

      // Format date values
      this.data.forEach((row) => {
        row.forEach((cell, index) => {
          if (typeof cell === 'number' && index === 42) {
            row[index] = SSF.format('yyyy-mm-dd hh:mm:ss', cell);
          }
        });
      });

      this.dataSheet2.forEach((row) => {
        row.forEach((cell, index) => {
          if (typeof cell === 'number' && index === 2) {
            row[index] = SSF.format('yyyy-mm-dd hh:mm:ss', cell);
          }
        });
      });

      this.dataSheet3.forEach((row) => {
        row.forEach((cell, index) => {
          if (typeof cell === 'number' && index === 2) {
            row[index] = SSF.format('yyyy-mm-dd hh:mm:ss', cell);
          }
        });
      });

      this.getCustomerBusinessName();
      this.fileInput.nativeElement.value = '';
    };
    reader.readAsBinaryString(target.files[0]);
  }

  getCustomerBusinessName() {
    if (!this.selectedCustomer) {
      this.hangleOverlay(
        'No se encontró el cliente con material diferente a granel, favor de intentarlo de nuevo',
        'bi bi-exclamation-circle-fill',
        false,
        3000
      );
      return;
    }
    this.loading = true;
    this.loteSvc.getCustomerBusinessName(this.selectedCustomer.customer_id)
    .subscribe({
      next: (customerBusinessName) => {
        // Falta llamar a dataToJSON
        // Las razones sociales son para agregar la propiedad adress y validar que las razones sociales correspondan al cliente
        this.customerBusinessName = [...customerBusinessName];
        this.validateData();
      },
      error: () => {
        this.loading = false;
        this.hangleOverlay(
          'Error al obnetener las razones sociales para validar, inténtelo más tarde',
          'bi bi-exclamation-circle-fill',
          false,
          3000
        );
      }
    });
  }

  validateData() {
    this.JsonData = this.dataToJsonFormat(this.data);
    this.JsonDataSheet2 = this.dataToJsonFormat(this.dataSheet2);
    this.JsonDataSheet3 = this.dataToJsonFormat(this.dataSheet3);
    this.currentUser = this.localStorageSvc.getData('userEmail');
    this.formattedData.pieces_batch = [];
    this.errorMessage = '';
    this.isLengthError = false;
    let isThereCustomerBusinessName = true;

    this.JsonData.forEach( (rowData: any, rowIndex: number) => {
      // Fila del Excel: +2 porque la fila 1 son encabezados y el índice es base 0.
      const excelRow: number = rowIndex + 2;
      const batchProperties: any = {};
      const entryProperties: any = {};
      for (let property in rowData) {
        if (rowData.hasOwnProperty(property) && !this.entryProperties.includes(property)) {
          if (property === 'customer_id' || property === 'material_id') {
            this.errorMessage = Number(rowData[property]) === this.selectedCustomer[property] ? this.errorMessage : `La columna '${property}' debe ser igual a la del cliente de piezas`;
          }
          if (property === 'packing_id') {
            this.errorMessage = Number(rowData[property]) !== 1 ? this.errorMessage : `La columna '${property}' debe ser diferente a granel`;
          }
          if (property === 'days_free_storage' && (!rowData[property] || !this.checkNumber(rowData[property])) ) {
            batchProperties[property] = 30;
          } else if (property === 'special_storage_rate' && (!rowData[property] || !this.checkNumber(rowData[property])) ) {
            batchProperties[property] = 0;
          } else if (property === 'storage_fee' && (!rowData[property] || !this.checkNumber(rowData[property])) ) {
            batchProperties[property] = 0.04;
          } else if (property === 'merchandise_fiscalized_area') {
            batchProperties[property] = rowData[property] === 'false' ? false : true;
          } else if (property === 'volume_occupied_merchandise') {
            batchProperties[property] = Number(rowData[property]) > 0 ? Number(rowData[property]) : 0;
          } else if (this.stringProperties.includes(property)) {
            batchProperties[property] = this.checkStringValue(rowData[property]);
            if (this.requiredBatchProperties.includes(property)) {
              this.errorMessage = batchProperties[property] ? this.errorMessage : `La columna '${property}' es obligatoria`;
            }
            const maxLengthError = this.checkMaxLength(property, batchProperties[property], excelRow);
            if (maxLengthError) {
              this.errorMessage = maxLengthError;
              this.isLengthError = true;
            }
          } else if (this.dateProperties.includes(property)) {
            if (this.checkDate(rowData[property])) {
              batchProperties[property] = rowData[property];
            } else {
              this.errorMessage = 'El formato de la fecha debe ser "yyyy-mm-dd hh:mm:ss"';
              batchProperties[property] = '';
            }
          } else if (this.numericProperties.includes(property)) {
            if (this.checkNumber(rowData[property])) {
              batchProperties[property] = Number(rowData[property]);
              if (property === 'quantity_pieces') {
                batchProperties[property] = Math.round(Number(rowData[property]))
              }
              if (property === 'tonnage' && batchProperties[property] === 0) {
                this.errorMessage = `La columna '${property}' no puede ser 0`;
              }
            } else {
              if (this.requiredBatchProperties.includes(property)) {
                this.errorMessage = batchProperties[property] ? 'Columnas numericas no pueden contener texto' : `La columna '${property}' es obligatoria`;
              } else {
                this.errorMessage = 'Columnas numericas no pueden contener texto';
              }
              batchProperties[property] = 0;
            }
          } else {
            batchProperties[property] = rowData[property];
          }
        }
        if (rowData.hasOwnProperty(property) && this.entryProperties.includes(property)) {
          if (this.numericProperties.includes(property)) {
            if (this.checkNumber(rowData[property])) {
              entryProperties[property] = Number(rowData[property]);
            } else {
              this.errorMessage = entryProperties[property] ? 'Columnas numericas no pueden contener texto' : `La columna '${property}' es obligatoria`;
              entryProperties[property] = 0;
            }
          } else if (this.dateProperties.includes(property)) {
            if (this.checkDate(rowData[property])) {
              entryProperties[property] = rowData[property];
            } else {
              this.errorMessage = entryProperties[property] ? 'El formato de la fecha debe ser "yyyy-mm-dd hh:mm:ss"' : `La columna '${property}' es obligatoria`;
              entryProperties[property] = '';
            }
          } else if (this.stringProperties.includes(property)) {
            entryProperties[property] = this.checkStringValue(rowData[property]);
            if (this.entryProperties.includes('customs_agent')) {
              this.errorMessage = entryProperties[property] ? this.errorMessage : `La columna '${property}' es obligatoria`;
            }
            const maxLengthError = this.checkMaxLength(property, entryProperties[property], excelRow);
            if (maxLengthError) {
              this.errorMessage = maxLengthError;
              this.isLengthError = true;
            }
          } else {
            entryProperties[property] = rowData[property];
          }
        }
      }

      const currentLocation = Number(entryProperties.location_id_entry);
      const currenCustomerBusinessName = this.customerBusinessName.find( customer => customer.id_business_name === Number(batchProperties.id_business_name));
      if (!currenCustomerBusinessName) {
        isThereCustomerBusinessName = false;
      }
      delete entryProperties.location_id_entry;
      this.formattedData.pieces_batch.push({
        ...batchProperties,
        days_free_storage: Number(batchProperties.days_free_storage),
        special_storage_rate: Number(batchProperties.special_storage_rate),
        storage_fee: Number(batchProperties.storage_fee),
        origin: this.blDetails.port_origin_name,
        address: currenCustomerBusinessName?.address,
        docking_date: this.blDetails.docking_date,
        undocking_date: this.blDetails.undocking_date,
        entry: batchProperties.entry === 'true' ? true : false,
        previous_registration_sample_collection: [ ...this.sheetValues(batchProperties.previous_registration_id, CheckSheets.previous_registration_id) ],
        customs_embargoed_merchandise: [ ...this.sheetValues(batchProperties.identification_stored_merchandise_id, CheckSheets.identification_stored_merchandise_id) ],
        merchandise_entry: {
          ...entryProperties,
          input_type_id: 1,
          batch_status_id: 1,
          operation_no: 0,
          precinct_key: 201,
          location_id: currentLocation,
          total_pieces: batchProperties.quantity_pieces,
          tonnage: batchProperties.tonnage,
          boat_no: this.blDetails.operation_number,
          ship_name: this.blDetails.boats_name,
          user_update_id: this.currentUser,
          user_create_id: this.currentUser
        }
      });
    });
    this.formattedData.bl_id = this.selectedCustomer?.bl_id || 0;

    this.loading = false;
    if (!isThereCustomerBusinessName) {
      this.hangleOverlay(
        'Favor de revisar id_business_name, no coincide con el cliente seleccionado',
        'bi bi-exclamation-circle-fill',
        false,
        3000
      );
      return;
    }
    if (this.errorMessage) {
      // Para errores de longitud, el overlay se muestra con botón y sin cierre
      // automático para que el usuario pueda leer qué fila y columna corregir.
      this.hangleOverlay(
        this.errorMessage,
        'bi bi-exclamation-circle-fill',
        this.isLengthError,
        this.isLengthError ? 0 : 3000
      );
      return;
    }
    if (!this.checkTotalPieces()) {
      this.hangleOverlay(
        'La suma de piezas registradas es mayor a las del cliente',
        'bi bi-exclamation-circle-fill',
        false,
        3000
      );
      setTimeout(() => {
        this.onLoadFile.emit(this.formattedData);
      }, 3000);
      return;
    }

    this.onLoadFile.emit(this.formattedData);
  }

  /**
   * Convierte una matriz de filas en un arreglo de objetos usando la primera
   * fila como cabeceras, omitiendo las filas vacías.
   * @param data - Matriz de filas leída de la hoja de cálculo.
   * @returns Arreglo de objetos con los datos de cada fila.
   */
  dataToJsonFormat(data: AOA) {
    // Obtener la primera fila que contiene los títulos de columna
    const headers: string[] = data[0];

    // Resto de las filas con datos
    const dataRows: any[] = data.slice(1);

    // Convertir los datos al formato deseado (clave: valor)
    const formattedData: any[] = [];
    dataRows.forEach(row => {
      const rowData: any = {};
      let isEmpty: boolean = true;
      headers.forEach((header, index) => {
        rowData[header] = row[index];
        if (rowData[header]) {
          isEmpty = false;
        }
      });
      if (!isEmpty) {
        formattedData.push(rowData);
      }
    });

    return formattedData;
  }

  /**
   * Selecciona el cliente con piezas a partir de su identificador.
   * @param customer_id - Identificador del cliente a seleccionar.
   */
  findCustomer(customer_id: number) {
    this.selectedCustomer = this.customersWithPieces.find( customer => customer.id === customer_id)
  }

  togleCustomerOverlay() {
    this.customerOverlay = !this.customerOverlay;
  }

  validateCustomerId() {
    if (this.customerId.invalid) {
      this.hangleOverlay(
        'Favor de seleccionar un cliente',
        'bi bi-exclamation-circle-fill',
        false,
        3000
      );
      return;
    }
    this.findCustomer(Number(this.customerId.value));
    this.togleCustomerOverlay();
    this.loadFile();
  }

  loadFile() {
    const fileInput = document.getElementById('batch-excel');
    if (fileInput) {
      fileInput.click();
    }
  }

  checkTotalPieces() {
    const totalPieces = this.formattedData.pieces_batch.reduce((sum, batch) => sum + batch.quantity_pieces, 0);
    if (this.selectedCustomer) {
      return this.selectedCustomer?.quantity_pieces >= totalPieces ? true : false;
    }
    return false;
  }

  /**
   * Muestra un overlay con un mensaje y lo oculta tras el tiempo indicado.
   * Si `time` es menor o igual a 0, el overlay permanece visible hasta que el
   * usuario lo cierre con un botón (ver `closeErrorOverlay`).
   * @param message - Mensaje a mostrar.
   * @param icon - Clase del icono a mostrar.
   * @param buttons - Indica si el overlay muestra botones.
   * @param time - Tiempo en milisegundos antes de ocultar el overlay. Usar 0
   *   (o un valor negativo) para que no se oculte automáticamente.
   */
  hangleOverlay(message: string, icon: string, buttons: boolean, time: number) {
    this.message = message;
    this.icon = icon;
    this.buttons = buttons;
    this.errorOverlay = true;
    if (time > 0) {
      setTimeout(() => {
        this.errorOverlay = false;
      },time);
    }
  }

  /**
   * Cierra el overlay de error. Se usa cuando el overlay se muestra con botón
   * y no se oculta automáticamente por tiempo.
   */
  closeErrorOverlay() {
    this.errorOverlay = false;
    this.buttons = false;
  }

  /**
   * Convierte un valor a cadena, devolviendo `undefined` si es nulo o indefinido.
   * @param valor - Valor a convertir.
   * @returns El valor como cadena o `undefined`.
   */
  checkStringValue(valor: any): string | undefined {
    if (valor !== undefined && valor !== null) {
      return String(valor);
    } else {
      return undefined;
    }
  }

  /**
   * Verifica si un valor representa un número válido (entero o decimal).
   * @param value - Valor a verificar.
   * @returns `true` si el valor es un número válido.
   */
  checkNumber(value: unknown): boolean {
    const regex = /^(?:\d+\.)?\d+$/;
    if (typeof value === 'string') {
      return regex.test(value);
    }
    if (typeof value === 'number') {
      return true;
    }
    return false;
  }

  /**
   * Verifica que un valor de texto no exceda el largo máximo permitido para su
   * columna (según el esquema del backend). Devuelve un mensaje de error que
   * indica la fila y el campo cuando se excede, o una cadena vacía si es válido.
   * @param property - Nombre de la columna a validar.
   * @param value - Valor de la celda a validar.
   * @param excelRow - Número de fila del Excel donde está el valor.
   * @returns Mensaje de error con fila y campo, o cadena vacía si es válido.
   */
  checkMaxLength(property: string, value: unknown, excelRow: number): string {
    const maxLength = this.stringMaxLengths[property];
    if (maxLength === undefined || value === undefined || value === null) {
      return '';
    }
    const length = String(value).length;
    if (length > maxLength) {
      return `La columna '${property}' en la fila ${excelRow} excede el máximo de ${maxLength} caracteres (tiene ${length})`;
    }
    return '';
  }

  /**
   * Verifica si un valor es una fecha válida con el formato esperado
   * "yyyy-mm-dd" (opcionalmente con hora).
   * @param value - Valor a verificar.
   * @returns `true` si el valor es una fecha válida.
   */
  checkDate(value: any): boolean {
    if (value instanceof Date) {
      return !isNaN(value.getTime());
    }

    if (typeof value === 'string') {
      const regex = /^\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2}:\d{2})?$/;
      return regex.test(value) && !isNaN(Date.parse(value));
    }

    return false;
  }

  /**
   * Obtiene y valida las filas de las hojas secundarias asociadas a un
   * identificador (registro previo o mercancía almacenada).
   * @param value - Identificador por el que se filtran las filas.
   * @param sheet - Hoja secundaria a consultar.
   * @returns Las filas validadas correspondientes al identificador.
   */
  sheetValues(value: unknown, sheet: CheckSheets): any[] {
    if (this.checkNumber(value)) {
      let currentSheet: any[];
      if (sheet === CheckSheets.previous_registration_id) {
        currentSheet = this.JsonDataSheet2.filter( (item: any) => item.previous_registration_id === Number(value));
      } else {
        currentSheet = this.JsonDataSheet3.filter( (item: any) => item.identification_stored_merchandise_id === Number(value));
      }
      currentSheet = this.checkSheet(currentSheet, sheet);
      return currentSheet;
    }
    return [];
  }

  /**
   * Valida y normaliza las filas de una hoja secundaria, convirtiendo fechas,
   * cadenas y números según el tipo de cada columna.
   * @param currentSheet - Filas a validar.
   * @param numberSheet - Hoja secundaria de origen (para los mensajes de error).
   * @returns Las filas validadas y normalizadas.
   */
  checkSheet(currentSheet: any[], numberSheet: CheckSheets): any[] {
    return currentSheet.map( (rowData: any) => {
      const properties: any = {};
      for (let property in rowData) {
        if (rowData.hasOwnProperty(property)) {
          if (this.dateProperties.includes(property)) {
            if (this.checkDate(rowData[property])) {
              properties[property] = rowData[property];
            } else {
              this.errorMessage = `El formato de la fecha en la hoja ${numberSheet} debe ser "yyyy-mm-dd hh:mm:ss"`;
              properties[property] = '';
            }
          } else if (this.stringProperties.includes(property)) {
            properties[property] = this.checkStringValue(rowData[property]);
          } else if (this.numericProperties.includes(property)) {
            if (this.checkNumber(rowData[property])) {
              properties[property] = Number(rowData[property]);
            } else {
              this.errorMessage = `Columnas numericas en la hoja ${numberSheet} no pueden contener texto`;
              properties[property] = 0;
            }
          } else {
            delete rowData[property];
          }
        }
      }
      return properties;
    });
  }
}
